import { useI18n } from "i18n";
import { commonPassword } from "../utils";
import { PASSWORD_DEFAULTS } from "../constants";

const usePasswordValidation = (onFailure?: () => void) => {
  const { t } = useI18n(["auth"]);

  const validatePassword = (password: string) => {
    let message = "";
    let error = false;

    if (!password) message = t("auth:enter.password");

    if (password && password.length < PASSWORD_DEFAULTS.MIN_LENGTH)
      message = t("auth:min.password.limit", {
        length: PASSWORD_DEFAULTS.MIN_LENGTH,
      });

    if (password && password.length > PASSWORD_DEFAULTS.MAX_LENGTH)
      message = t("auth:max.password.limit", {
        length: PASSWORD_DEFAULTS.MAX_LENGTH,
      });

    if (password && commonPassword(password)) message = t("auth:weak.password");

    if (message) error = true;

    if (error) {
      onFailure?.();

      return { value: password ?? "", error: true, message };
    }

    return { value: password, error: false, message };
  };

  return { validatePassword };
};

export default usePasswordValidation;
